import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = {
  style: {
    "text-align": "right",
    "padding-top": "10px"
  }
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存");

import { computed, watch, ref, reactive } from 'vue';
import { useStore } from 'vuex';
import { getVexTableProps } from '@/config';
import { getBranchInfoBySupplierId, getBranchCustInfoList } from '@/request';
export default {
  name: 'branch-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierId: [String, Number]
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const store = useStore();
    store.dispatch('getDictList');
    const areaList = computed(() => store.state.dictList);
    const table = ref();
    watch(() => props.modelValue, v => {
      if (v) {
        var _table$value;

        form.branchName = '';
        form.branchArea = '';
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });
    const form = reactive({
      branchName: '',
      branchArea: ''
    });
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'radio',
        width: '50px'
      }, {
        title: '发货方名称',
        field: 'branchName'
      }, {
        title: '发货方编号',
        field: 'branchId'
      }, {
        title: '业务区域',
        field: 'businessAreaName'
      }, {
        title: '详细地址',
        field: 'address'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getBranchInfoBySupplierId(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize,
              supplierId: props.supplierId
            }, form)).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.branchInfoList
              });
            });
          })
        }
      }
    });

    function submit() {
      let selectRow = table.value.getRadioRecord();
      visible.value = false;
      emit('success', selectRow);
    }

    function resetHandle() {
      form.branchName = undefined;
      form.branchArea = undefined;
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "发货方信息",
        width: "80%",
        top: "5vh"
      }, {
        footer: _withCtx(() => [_createElementVNode("footer", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "发货方名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.branchName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.branchName = $event),
              placeholder: "请输入发货方名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "业务区域"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.branchArea,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.branchArea = $event),
              placeholder: "请选择",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(areaList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  value: item.id,
                  label: item.text,
                  key: item.id
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Search",
              onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "primary",
              icon: "Refresh",
              onClick: resetHandle
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _unref(visible) ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0,
          ref_key: "table",
          ref: table
        }, _unref(tableOptions)), null, 16)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};